export default __webpack_public_path__ + "static/media/Jana_Gana_Mana_instrumental.ec39ce68.mp3";